'use client';

import { createZustandStore } from '../../zustand';

import { IRegionState } from './types';

import {
  loadPersistedRegionStore,
  updateActiveRegionCallback,
  updateAppLanguageCallback,
  updateTenantConfig,
} from './callbacks';

/**
 * This creates a local region state tracker and update callbacks to track the
 * actively selected region.
 *
 * This acts as a fallback when there is no current `activeSession` whose region
 * can be used.
 */
export const useRegionStore = createZustandStore<IRegionState>((set) => {
  const localRegionData = loadPersistedRegionStore();

  return {
    appLanguage: localRegionData?.appLanguage || 'en',
    region: localRegionData?.region || null,
    tenantConfig: localRegionData?.tenantConfig || null,
    updateActiveRegion: updateActiveRegionCallback(set),
    updateAppLanguage: updateAppLanguageCallback(set),
    onUpdateTenantConfig: updateTenantConfig(set),
  };
});
